import {
  IJackpotNormalized,
  JackpotType,
  NormalizedJackpotsType
} from '../../../types';
import { IInHouseJackpotsState, useInHouseJackpotsStore } from '../../store';

export const selectJackpotByType = (
  jackpots: NormalizedJackpotsType,
  jackpotType: JackpotType
) => jackpots[jackpotType];

export const useJackpotByType = (
  jackpotType: JackpotType
): IJackpotNormalized =>
  useInHouseJackpotsStore(({ jackpots }: IInHouseJackpotsState) =>
    selectJackpotByType(jackpots, jackpotType)
  );
